class CartProvisions extends HTMLElement {
  constructor() {
    super();
    this.cartUpdateUnsubscriber = undefined;
    this.provisionsSection = null;
    this.cartItemsContainer = null;
    this.observer = null;

    // Wait for DOM to be ready
    setTimeout(() => {
      this.provisionsSection =
        this.querySelector('#dr-provisions-section') || this.querySelector('#dr-provisions-section-drawer');
      this.cartItemsContainer = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');

      if (this.provisionsSection) {
        this.hideAllItems();
        this.initializeCartState();
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.cartData) this.updateProvisions(event.cartData);
        });

        if (this.cartItemsContainer) {
          this.observer = new MutationObserver(() => {
            const cartItems = this.cartItemsContainer.querySelectorAll('.cart-item');
            if (cartItems.length === 0) {
              this.hideAllItems();
            } else {
              this.initializeCartState();
            }
          });

          this.observer.observe(this.cartItemsContainer, {
            childList: true,
            subtree: true,
          });
        }
      }
    }, 100);
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
    if (this.observer) this.observer.disconnect();
  }

  hideAllItems() {
    const items = this.provisionsSection.querySelectorAll('[data-provision-type]');
    items.forEach((item) => (item.style.display = 'none'));
    this.provisionsSection.style.display = 'none';
  }

  async initializeCartState() {
    try {
      const response = await fetch(window.routes.cart_url + '.js');
      const cartData = await response.json();
      this.updateProvisions(cartData);
    } catch (error) {
      console.error('Error fetching cart data:', error);
    }
  }

  updateProvisions(cartData) {
    if (!cartData || !this.provisionsSection) return;

    const cartItems = cartData.items || [];
    const provisionProducts = window.theme?.settings?.provision_products || {};
    const dr_outerwear = cartItems.some((item) => item.product_type === 'Outerwear' && item.final_price >= 70000);
    const dr_footwear = cartItems.some((item) => item.product_type === 'Boots' || item.product_type === 'Shoes');
    // New dr_socks logic: sum of all items except those qualifying for dr_outerwear, dr_footwear, and dr_socks_provision
    const socksEligibleTotal = cartItems
      .filter(
        (item) =>
          !(
            (item.product_type === 'Outerwear' && item.final_price >= 70000) ||
            item.product_type === 'Boots' ||
            item.product_type === 'Shoes' ||
            (provisionProducts.socks && item.product_id === provisionProducts.socks.id)
          )
      )
      .reduce((sum, item) => sum + item.final_price * item.quantity, 0);
    const dr_socks = socksEligibleTotal >= 50000;

    // Check if provision products from settings are already in the cart
    const hasOuterwearProvision = cartItems.some(
      (item) => provisionProducts.outerwear && item.product_id === provisionProducts.outerwear.id
    );
    const hasFootwearProvision = cartItems.some(
      (item) => provisionProducts.footwear && item.product_id === provisionProducts.footwear.id
    );
    const hasSocksProvision = cartItems.some(
      (item) => provisionProducts.socks && item.product_id === provisionProducts.socks.id
    );

    const provisionTypes = ['outerwear', 'footwear', 'socks'];
    const conditions = [
      dr_outerwear && !hasOuterwearProvision,
      dr_footwear && !hasFootwearProvision,
      dr_socks && !hasSocksProvision,
    ];

    provisionTypes.forEach((type, index) => {
      const item = this.provisionsSection.querySelector(`[data-provision-type="${type}"]`);
      if (item) {
        const originalPrice = parseInt(item.dataset.originalPrice);
        const discount = parseInt(item.dataset.discount);
        const discountedPrice = originalPrice - discount * 100;
        this.updateProvisionPrice(item, originalPrice, discountedPrice);
        item.style.display = conditions[index] ? 'block' : 'none';
      }
    });

    this.provisionsSection.style.display = conditions.some(Boolean) ? 'block' : 'none';

    // Hide the entire cart-provisions element if no provisions are shown
    this.style.display = conditions.some(Boolean) ? 'block' : 'none';
  }

  updateProvisionPrice(element, originalPrice, discountedPrice) {
    const priceContainer = element.querySelector('.price');
    if (!priceContainer) return;

    priceContainer.classList.add('price--on-sale');
    const formattedOriginalPrice = (originalPrice / 100).toFixed(2);
    const formattedDiscountedPrice = (discountedPrice / 100).toFixed(2);

    let regularPriceDiv = priceContainer.querySelector('.price__regular') || document.createElement('div');
    let salePriceDiv = priceContainer.querySelector('.price__sale') || document.createElement('div');

    regularPriceDiv.className = 'price__regular';
    salePriceDiv.className = 'price__sale';

    if (!priceContainer.contains(regularPriceDiv)) priceContainer.appendChild(regularPriceDiv);
    if (!priceContainer.contains(salePriceDiv)) priceContainer.appendChild(salePriceDiv);

    // Ensure both price divs are visible
    regularPriceDiv.style.display = 'block';
    salePriceDiv.style.display = 'block';

    regularPriceDiv.innerHTML = `
      <span class="visually-hidden visually-hidden--inline">Regular price</span>
      <span>
        <s class="price-item price-item--large dr-sale-price">
          <span class="money">$${formattedOriginalPrice}</span>
        </s>
      </span>
    `;

    salePriceDiv.innerHTML = `
      <span class="visually-hidden visually-hidden--inline">Sale price</span>
      <span class="price-item price-item--sale price-item--last">
        <span class="money">$${formattedDiscountedPrice}</span>
      </span>
    `;
  }
}

customElements.define('cart-provisions', CartProvisions);
